import React from "react";
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from "./App";
import { store } from "./store/store";
import PersistProvider from "./store/providers/persist-provider";
import { fetchProducts } from "./store/slices/product-slice"
import products from "./data/products.json";
import 'animate.css';
import 'swiper/swiper-bundle.min.css';
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "./assets/scss/style.scss";
import "./assets/css/newui.css";
import "./assets/css/auth-redesign.css";
import "./assets/css/navbar-redesign.css";
import "./assets/css/home-redesign.css";
import "./assets/css/coming-soon.css";
import "./assets/css/shop-redesign.css";
import "./assets/css/product-redesign.css";
import "./assets/css/cart-redesign.css";
import "./assets/css/checkout-redesign.css";
import "./assets/css/order-redesign.css";
import "./assets/css/track-redesign.css";
import "./assets/css/return-redesign.css";
import "./assets/css/profile-redesign.css";
import "./assets/css/about-redesign.css";
import "./assets/css/contact-redesign.css";
import "./assets/css/cart-drawer.css";
import "./assets/css/mobile.css";
import "./assets/css/image-protection.css";
import "./i18n";


store.dispatch(fetchProducts());


const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <Provider store={store}>
      <PersistProvider>
        <App />
      </PersistProvider>
    </Provider>
);

